var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_vm._t("default"),_c('div',{staticClass:"tooltip",class:{ active: _vm.isActive }},[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }